class MiniCart {
  constructor() {
    this.cart = document.getElementById('mini-cart');
    this.cartForm = document.getElementById('mini-cart-form');
    this.cartData = null;
    this.isLoading = false;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.fetchCartData();
  }

  setupEventListeners() {
    if (this.cartForm) {
      this.cartForm.addEventListener('change', (e) => {
        if (e.target.matches('.quantity-selector__input')) {
          this.handleQuantityChange(e);
        }
      });

      this.cartForm.addEventListener('click', (e) => {
        if (e.target.matches('.line-item__remove-button')) {
          e.preventDefault();
          this.handleRemoveItem(e);
        }
      });
    }
  }

  setLoading(loading) {
    this.isLoading = loading;
    this.cart.classList.toggle('mini-cart--loading', loading);
  }

  async fetchCartData() {
    if (this.isLoading) return;
    
    this.setLoading(true);
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Network response was not ok');
      this.cartData = await response.json();
      return this.cartData;
    } catch (error) {
      console.error('Error fetching cart data:', error);
      return null;
    } finally {
      this.setLoading(false);
    }
  }

  async handleQuantityChange(event) {
    const input = event.target;
    const lineItem = input.closest('line-item');
    const lineNumber = input.dataset.line;
    const quantity = parseInt(input.value, 10);

    if (isNaN(quantity)) return;

    this.setLoading(true);
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: lineNumber,
          quantity: quantity
        })
      });

      if (!response.ok) throw new Error('Network response was not ok');
      await this.fetchCartData();
      this.updateLineItemPrice(lineItem, lineNumber);
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      this.setLoading(false);
    }
  }

  updateLineItemPrice(lineItem, lineNumber) {
    if (lineItem && this.cartData) {
      const priceElement = lineItem.querySelector('.price');
      const updatedLineItem = this.cartData.items[lineNumber - 1];
      if (priceElement && updatedLineItem) {
        priceElement.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.cartData.currency
        }).format(updatedLineItem.final_line_price / 100);
      }
    }
  }

  async handleRemoveItem(event) {
    const link = event.target;
    const lineItem = link.closest('line-item');
    
    if (!lineItem) return;

    this.setLoading(true);
    try {
      const response = await fetch(link.href);
      if (!response.ok) throw new Error('Network response was not ok');
      lineItem.remove();
      await this.fetchCartData();
      this.updateCartUI();
    } catch (error) {
      console.error('Error removing item:', error);
    } finally {
      this.setLoading(false);
    }
  }

  updateCartUI() {
    const cartCount = document.querySelector('.header__cart-count');
    const totalPrice = document.querySelector('.mini-cart-footer-total .price');

    if (cartCount && this.cartData) {
      cartCount.textContent = this.cartData.item_count;
    }

    if (totalPrice && this.cartData) {
      totalPrice.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: this.cartData.currency
      }).format(this.cartData.total_price / 100);
    }
  }
}

// Initialize the mini cart
window.addEventListener('DOMContentLoaded', () => {
  new MiniCart();
}); 